const _data = []
for (let i = 0; i < 17; i++) {
  _data[i] = `${i + 7}:00`
}

export const optionLine = {
  xAxis: {
    name: 'Time',
    boundaryGap: false,
    type: 'category',
    data: _data
  },
  tooltip: {
    trigger: 'axis'
  },
  yAxis: {
    name: 'Value',
    type: 'value'
  },
  series: [{
    data: [150, 230, 224, 218, 135, 147, 260],
    type: 'line',
    label: {
      show: true,
      position: 'top'
    }
    // areaStyle: {}
  }]
}
